var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveIntegrationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2396 13.44V11.7802C19.1996 11.567 19.5865 11.2032 20.0991 10.7347L21.5986 11.568L23.0377 9.07391L21.5948 8.24255C21.7561 7.51295 21.7397 6.83231 21.5919 6.15935L23.0242 5.32799L21.5708 2.83295L20.0981 3.66623C19.5865 3.19679 19.1996 2.83391 18.2396 2.61983V0.959991H15.3596V2.61983C14.3996 2.83391 14.0127 3.19679 13.501 3.66623L12.0284 2.83295L10.574 5.32703L12.0063 6.15839C11.8585 6.83231 11.8421 7.51295 12.0034 8.24159L10.5605 9.07295L11.9996 11.567L13.4991 10.7338C14.0127 11.2032 14.3996 11.567 15.3596 11.7802V13.44H18.2396Z",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63998 23.04V21.3802C9.59998 21.167 9.98686 20.8032 10.4995 20.3347L11.999 21.167L13.4381 18.673L11.9952 17.8416C12.1565 17.112 12.1401 16.4314 11.9923 15.7574L13.4246 14.927L11.9702 12.433L10.4976 13.2662C9.98686 12.7968 9.59998 12.4339 8.63998 12.2198V10.56H5.75998V12.2198C4.79998 12.4339 4.4131 12.7968 3.90142 13.2662L2.42878 12.433L0.974377 14.927L2.4067 15.7574C2.25886 16.4314 2.24254 17.112 2.40382 17.8416L0.960938 18.673L2.39998 21.167L3.8995 20.3347C4.4131 20.8032 4.79998 21.167 5.75998 21.3802V23.04H8.63998Z",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7999 9.12C17.8603 9.12 18.7199 8.26039 18.7199 7.2C18.7199 6.13961 17.8603 5.28 16.7999 5.28C15.7395 5.28 14.8799 6.13961 14.8799 7.2C14.8799 8.26039 15.7395 9.12 16.7999 9.12Z",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20027 18.72C8.26066 18.72 9.12027 17.8604 9.12027 16.8C9.12027 15.7396 8.26066 14.88 7.20027 14.88C6.13989 14.88 5.28027 15.7396 5.28027 16.8C5.28027 17.8604 6.13989 18.72 7.20027 18.72Z",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIntegrationIcon);
export default __webpack_public_path__ + "static/media/active_integration_icon.f1d6d0a91797bc5f8abe9e3a7385f5f9.svg";
export { ForwardRef as ReactComponent };